import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { heroContent } from '../data/tables';
export function Hero() {
  return <header className="bg-paper" data-id="element-132" data-mp="ei1v1l1sq0xf">
      <div className="mx-auto max-w-content px-5 pb-14 pt-10 sm:px-8 md:pb-28 md:pt-20" data-id="element-133" data-mp="9k0eb6ruedp4">
        <div className="grid items-center gap-10 md:grid-cols-[1.05fr_0.95fr] md:gap-16" data-id="element-134" data-mp="4m8nyh6uizn1">
          <div data-id="element-135" data-mp="1297cu5rar3ad">
            <span className="inline-block border border-brass/50 bg-white px-3 py-1.5 font-mono text-[10px] uppercase leading-none tracking-label text-slate rounded-sharp" data-id="element-136" data-mp="129qv5nkuztox">
              {heroContent.badge}
            </span>

            <h1 className="mt-5 font-serif text-[36px] font-semibold leading-[1.08] tracking-[-0.015em] text-ink md:mt-7 md:text-[56px]" data-id="element-137" data-mp="sa02lrfuzorh">
              {heroContent.heading}
            </h1>

            <p className="mt-5 max-w-[36rem] text-[17px] leading-[1.6] text-slate md:mt-6 md:text-[18px]" data-id="element-138" data-mp="3d2bkbqsid1w2">
              {heroContent.subheading}
            </p>

            <ul className="mt-7 flex flex-wrap gap-1.5 md:mt-8 md:gap-2" data-id="element-139" data-mp="3j8sfs1yzrlqd">
              {heroContent.miniBadges.map(badge => <li key={badge} className="border border-brass/40 bg-white px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-label text-ink rounded-sharp md:px-3 md:text-[11px]" data-id="element-140" data-mp="3o6kd5bieo01y">
                  {badge}
                </li>)}
            </ul>

            <div className="mt-8 md:mt-9" data-id="element-141" data-mp="30ggg5mzq2yjx">
              <CtaButton data-id="element-142" data-mp="358hm6r6art1i">{heroContent.cta}</CtaButton>
              <TrustRow align="center" className="mt-4 sm:justify-start" data-id="element-143" data-mp="35aasu6gwud9i" />
            </div>
          </div>

          <figure className="mx-auto w-full max-w-[380px] border border-brass/30 bg-white p-3 shadow-paper rounded-sharp md:max-w-none md:p-4" data-id="element-144" data-mp="2qlofgaaufvkx">
            <img src="https://cdn.magicpatterns.com/uploads/5FcmdSg2j3aHu6j65escoo/daycare.png" alt={heroContent.imageAlt} width={1571} height={1963} loading="eager" decoding="async" className="aspect-[4/5] w-full object-cover object-center" data-id="element-145" data-mp="2hinaicxpsaiu" />
          </figure>
        </div>
      </div>
    </header>;
}